import styled from '@emotion/styled';

export const PivotTableChartWrapper = styled.div`
  margin-left: -15px;
  margin-right: -15px;
  margin-top: -15px;
  padding-top: 10px;
  height: calc(100% + 15px);
  position: relative;
`;

export const PivotTableFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background-color: var(--color-background-light);
  height: 50px;
  width: 100%;
  position: absolute;
  bottom: 0;
`;
